// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".document-container .vertical-line{height:23px;margin-left:17px;margin-right:11px;border-left:1.2px solid #cecece}.document-container .media-size{color:#cecece}.document-container .media-desc{font-size:15px}.document-container .media-extension{min-width:33px}", ""]);
// Exports
module.exports = exports;
